// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import Scroll from "react-scroll";
import Actions from "../../actions/Creators";
import I18n from "../../i18n/I18n";
import Helper from "../../helper/Helper";
import Dropdown from "../../components/common/filterDropdown/Dropdown";
import {
    Layout,
    Loader,
    Button,
    Icon,
    ToggleButton,
    EmptyResults,
    SearchString,
    Pagination,
    LocaleLink,
    DatePicker
} from "../../components/common/";
import { SalesTable, SalesDetails } from "../../components/sales";
import ReportsEmpty from "../../components/reports/ReportsEmpty";
import styles from "./Sales.scss";

class StockRequest extends Component {
    state = {
        limits: 40,
        page: 1,
        change: false,
        search: "",
        fromDate: moment().subtract(1, "months"),
        toDate: moment(),
        selectedStatus: "all"
    };

    componentDidMount = () => {
        this.getSalesStatus();
        if (this.props.user && this.props.seller) {
            if (this.props.match.params.salesItemNr)
                this.getSalesItemDetails(this.props.match.params.salesItemNr);
            else this.getSalesData();
        }
        if (this.props.location && this.props.location.search) {
            this.getParams(this.props.location.search);
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (this.state.change) {
            if (this.props.match.params.salesItemNr) {
                this.getSalesItemDetails(this.props.match.params.salesItemNr);
            } else this.getSalesData();
        }
        if (
            this.props.location &&
            prevProps.location &&
            this.props.location !== prevProps.location &&
            this.props.location.search
        ) {
            this.getParams(this.props.location.search);
        }
    };

    componentWillReceiveProps = nextProps => {
        if (
            this.props.match !== nextProps.match ||
            this.props.seller !== nextProps.seller
        ) {
            if (nextProps.match.params.salesItemNr)
                this.getSalesItemDetails(nextProps.match.params.salesItemNr);
            else this.getSalesData();
        }
    };

    getSalesData = () => {
        const { page, limits, search, fromDate, toDate, selectedStatus } = this.state;

        let query = `limits=${limits}&page=${page}`;
        query = search ? `${query}&search=${search}` : query;
        query =
            fromDate && toDate
                ? `${query}&from_date=${moment(fromDate).format(
                      "YYYY-MM-DD"
                  )}&to_date=${moment(toDate).format("YYYY-MM-DD")}`
                : query;
        query = selectedStatus !== 'all' ? `${query}&status=${selectedStatus}` : query;

        if (fromDate && toDate) this.props.dispatch(Actions.getSales(query));
        this.setState({
            change: false
        });
    };

    getSalesItemDetails = salesItemNr => {
        let query = `item_nr=${salesItemNr}`;
        if (salesItemNr)
            this.props.dispatch(Actions.getSalesItemDetails(query));
    };

    // TO GET SALES STATUS
    getSalesStatus = () => {
        this.props.dispatch(Actions.getSalesStatus());
    };

    perPage = e => {
        const newState = {};
        newState.limits = e;
        newState.page = 1;
        newState.change = true;
        this.setState(newState);
    };

    onPageChange = page => {
        const newState = {};
        newState.page = page.selected + 1;
        newState.selectedItems = [];
        newState.change = true;
        this.setState(newState);
    };

    onStatusChange = (e) => {
        const newState = {};
        newState.selectedStatus = e;
        newState.change = true;
        this.setState(newState);
    }

    onSearch = search => {
        const newState = {};
        newState.page = 1;
        newState.search = search;
        newState.change = true;
        newState.selectedItems = [];
        this.setState(newState);
    };

    clearSearch = () => {
        const newState = {};
        newState.search = "";
        newState.change = true;
        newState.selectedItems = [];
        this.setState(newState);
    };

    selectedFromDate = date => {
        const formatted = moment(date);

        let toDate = this.state.toDate;

        if (moment(toDate).isBefore(moment(formatted))) {
            toDate = "";
        }

        var newState = {};
        newState["fromDate"] = formatted;
        newState["toDate"] = moment(toDate);
        newState.page = 1;
        this.setState(newState);
    };

    selectedToDate = date => {
        const formatted = moment(date);

        let fromDate = this.state.fromDate;

        if (moment(fromDate).isAfter(moment(formatted))) {
            fromDate = "";
        }

        var newState = {};
        newState["toDate"] = formatted;
        newState["fromDate"] = moment(fromDate);
        newState.page = 1;

        this.setState(newState);
    };

    clearDate = () => {
        this.setState({ fromDate: "", toDate: "", change: true });
    };

    rangeSubmit() {
        this.setState({ change: true });
    }

    getParams = searchString => {
        const params = URLSearchParams ? new URLSearchParams(searchString) : "";
        const itemNr = params && params.get("item_nr");
        const from = params && params.get("from");
        const to = params && params.get("to");
        const newState = {};
        let haveParam = false;
        if (itemNr) {
            newState.search = itemNr;
            haveParam = true;
        }
        if (from && to) {
            newState.fromDate = moment(from);
            newState.toDate = moment(to);
            haveParam = true;
        }
        if (haveParam) {
            newState.change = true;
            this.setPageUrl();
            this.setState(newState);
        }
    };

    setPageUrl = () => {
        this.props.history.replace(`/${Helper.getLocale()}/sales`);
    };

    render() {
        const {
            browser,
            user,
            seller,
            isLoading,
            isSessionLoading,
            sales,
            match,
            salesItem,
            isNoonUser,
            salesStatus
        } = this.props;
        const { selectedStatus } = this.state;

        const { salesItemNr } = match.params;
        let title = "menu.sales";
        if (salesItemNr) title = "sales.financial-data";
        const { search } = this.state;

        let searchLabel = "sales.search-placeholder";

        const minimumDate = moment(this.state.fromDate || "");
        const maximumDate = moment(this.state.toDate || "");
        const minimumPaidAtDate = moment().subtract(1, "year");
        const maxDate = moment();

        const statusList = salesStatus ? salesStatus.statuses : "";

        let statusOptions = [{ label: I18n.getText('orders.All'), value: "all" }];

        if (statusList) {
            for (let i = 0; i < statusList.length; i++) {
                const statusItem = [];
                statusItem.label = statusList[i].name;
                statusItem.value = statusList[i].code;
                statusOptions.push(statusItem);
            }
        }

        const pageCount =
            sales && sales.items && sales.items.length < this.state.limits
                ? this.state.page
                : 100;

        const pageOptions = [
            {
                value: 40,
                key: 40,
                label: I18n.getText("stock-requests.per-page", { count: 40 })
            },
            {
                value: 80,
                key: 80,
                label: I18n.getText("stock-requests.per-page", { count: 80 })
            },
            {
                value: 120,
                key: 120,
                label: I18n.getText("stock-requests.per-page", { count: 120 })
            }
        ];
        return (
            <Layout
                currentIndex={12}
                title={title}
                search={this.state.search}
                searchLabel={!salesItemNr ? searchLabel : ""}
                onSearch={!salesItemNr ? this.onSearch : ""}
            >
                {isSessionLoading ? (
                    <Loader />
                ) : user &&
                seller &&
                (seller.is_allow_stock_request || isNoonUser) ? (
                    salesItemNr ? (
                        <div className={styles.ctr}>
                            {isLoading ? (
                                <Loader />
                            ) : salesItem && !_.isEmpty(salesItem) ? (
                                <SalesDetails
                                    item={salesItem}
                                    currencyCode={
                                        seller && seller.currency_code
                                    }
                                    lang={Helper.getLocale()}
                                    onLoad={this.getSalesItemDetails}
                                />
                            ) : (
                                <EmptyResults
                                    heading={I18n.getText(
                                        "stock-request.no-items"
                                    )}
                                />
                            )}
                        </div>
                    ) : (
                        <div className={styles.ctr}>
                            <div className={styles.filter}>
                                <div className={styles.datePicker}>
                                    <div className={styles.label}>
                                        {I18n.getText("sales.shipped-date")}
                                    </div>
                                    <DatePicker
                                        placeholder={"YYYY-MM-DD"}
                                        initialDate={this.state.fromDate}
                                        selectedDate={this.selectedFromDate}
                                        clearDate={!this.state.fromDate}
                                        isOutsideRange={day =>
                                            day.isBefore(minimumPaidAtDate) ||
                                            day.isAfter(maxDate) ||
                                            day.isAfter(maximumDate)
                                        }
                                    />
                                    <div className={styles.label}>
                                        {I18n.getText(
                                            "reports.date-to",
                                            {},
                                            "to"
                                        )}
                                    </div>
                                    <DatePicker
                                        placeholder={"YYYY-MM-DD"}
                                        selectedDate={this.selectedToDate}
                                        initialDate={this.state.toDate}
                                        clearDate={!this.state.toDate}
                                        isOutsideRange={day =>
                                            day.isBefore(minimumDate) ||
                                            day.isAfter(maxDate)
                                        }
                                    />
                                    <Button
                                        variant="transparent"
                                        onClick={() => this.rangeSubmit()}
                                        disabled={
                                            !this.state.fromDate ||
                                            !this.state.toDate
                                        }
                                    >
                                        {I18n.getText(
                                            "reports.generate-btn",
                                            {},
                                            "Go"
                                        )}
                                    </Button>
                                    <Button
                                        variant="transparent"
                                        onClick={this.clearDate}
                                        className={styles.clear}
                                        disabled={
                                            !this.state.fromDate &&
                                            !this.state.toDate
                                        }
                                    >
                                        {I18n.getText(
                                            "reports.clear",
                                            {},
                                            "Clear"
                                        )}
                                    </Button>
                                </div>
                                <div className={styles.dropdownCtr}>
                                    <div className={styles.eachFilter}>
                                        <Dropdown
                                            onChange={this.onStatusChange}
                                            selected={selectedStatus}
                                            options={statusOptions}
                                            label={I18n.getText("sales.status")}
                                        />
                                    </div>
                                    <div className={styles.eachFilter}>
                                        <Dropdown
                                            onChange={this.perPage}
                                            selected={this.state.limits}
                                            options={pageOptions}
                                            label={I18n.getText("orders.display")}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                {search ? (
                                    <SearchString
                                        search={search}
                                        clearSearch={this.clearSearch}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                            {isLoading ? (
                                <Loader />
                            ) : sales &&
                            sales.items &&
                            !_.isEmpty(sales.items) ? (
                                this.state.fromDate && this.state.toDate ? (
                                    <div>
                                        <SalesTable
                                            data={sales.items}
                                            browser={browser}
                                            seller={seller}
                                            searchString={search}
                                        />
                                        {sales.no_of_pages &&
                                        sales.no_of_pages > 1 ? (
                                            <Pagination
                                                currentPage={this.state.page}
                                                onPageChange={this.onPageChange}
                                                pageCount={Number(
                                                    sales.no_of_pages
                                                )}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                ) : (
                                    <ReportsEmpty
                                        largeText={I18n.getText(
                                            "sales.no-date"
                                        )}
                                        medText=" "
                                    />
                                )
                            ) : (
                                <EmptyResults
                                    heading={I18n.getText(
                                        "stock-request.no-items"
                                    )}
                                />
                            )}
                        </div>
                    )
                ) : (
                    <EmptyResults
                        heading={I18n.getText("stock-request.no-items")}
                    />
                )}
            </Layout>
        );
    }
}
const mapStateToProps = state => {
    return {
        lang: state.locale.lang,
        user: state.session.user,
        seller: state.session.seller,
        isNoonUser: state.session.isNoonUser,
        isSessionLoading: state.session.isSessionLoading,
        browser: state.browser,
        isLoading: state.reports.isLoading,
        sales: state.reports.sales,
        salesItem: state.reports.salesItem,
        salesStatus: state.reports.salesStatus
    };
};

export default connect(mapStateToProps)(StockRequest);



// WEBPACK FOOTER //
// ./src/containers/sales/Sales.js